import { render, staticRenderFns } from "./OrderAll.vue?vue&type=template&id=11b5531a&scoped=true"
import script from "./OrderAll.vue?vue&type=script&lang=js"
export * from "./OrderAll.vue?vue&type=script&lang=js"
import style0 from "./OrderAll.vue?vue&type=style&index=0&id=11b5531a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b5531a",
  null
  
)

export default component.exports